import "core-js/modules/es.array.concat.js";
import { postReq, putReq, getReq, deleteReq } from './axios';
var BASE_URL = "".concat(apiUrl, "/borrower-income");
export var getBorrowerIncome = function getBorrowerIncome(idNumber, body) {
  return getReq("".concat(BASE_URL, "/").concat(idNumber), body);
};
export var addBorrowerIncome = function addBorrowerIncome(idNumber, body) {
  return postReq("".concat(BASE_URL, "/").concat(idNumber), body);
};
export var editBorrowerIncome = function editBorrowerIncome(id, body) {
  return putReq("".concat(BASE_URL, "/").concat(id), body);
};
export var deleteBorrowerIncome = function deleteBorrowerIncome(id) {
  return deleteReq("".concat(BASE_URL, "/").concat(id));
};